module.exports = __webpack_public_path__ + "media/images/icn-mail-f1e7b87799a37f8497900dfe40960d48.png";